var _path, _path2, _path3, _path4, _g, _path5, _path6, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7822 22.6606C18.9755 22.5763 19.1638 22.4812 19.3464 22.3758L23.827 19.7889C24.9057 19.166 26.2851 19.5357 26.9079 20.6144C27.1415 21.019 27.0029 21.5362 26.5983 21.7698L22.8938 23.9086M11.49 20.8789L13.3552 22.1511C14.3276 22.8146 15.4836 23.1566 16.6606 23.1291M16.2276 25.6951L27.3617 22.7117C28.6974 22.3538 30.0703 23.1465 30.4283 24.4822C30.5625 24.9831 30.2652 25.4979 29.7643 25.6321L25.3591 26.8125M18.4393 26.8138H29.6063C30.9891 26.8138 32.1101 27.9348 32.1101 29.3177C32.1101 29.8362 31.6897 30.2566 31.1712 30.2566H25.247M6.21036 17.9548L5.09815 19.24C4.03684 20.4664 2.59081 21.1962 1 21.1962",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2215 33.3627L28.5651 35.5762C28.7028 35.6334 28.8572 35.636 28.9968 35.5835C29.1364 35.5311 29.2508 35.4274 29.3167 35.2937L29.3331 35.2605C29.9758 33.9573 29.4493 32.3805 28.1531 31.7257C24.4591 29.8599 17.33 26.2539 13.7344 24.4351C13.0735 24.1008 12.5156 23.5934 12.1203 22.9671C11.7249 22.3407 11.5069 21.6189 11.4894 20.8784C11.4719 20.1412 11.6518 19.4126 12.0104 18.7682C12.369 18.1238 12.8932 17.5869 13.5289 17.2131L14.9621 16.3702C15.6374 15.9731 16.1972 15.4065 16.5861 14.7266C16.9751 14.0466 17.1797 13.2769 17.1797 12.4935C17.1797 11.2881 16.2024 10.3109 14.997 10.311C14.8614 10.311 14.7294 10.3551 14.621 10.4366C14.5125 10.5181 14.4335 10.6326 14.3958 10.7629L14.0982 11.7908C13.9665 12.2458 13.7332 12.6649 13.416 13.0167C13.0988 13.3684 12.7058 13.6435 12.2668 13.8214L10.5447 14.5189C9.49112 14.9456 8.52374 15.5602 7.68968 16.3326M1 29.3651L2.57717 29.1349C4.37335 28.8727 6.19937 28.8911 7.98989 29.1895L13.5143 30.1101C15.5765 30.4537 17.5928 31.0312 19.5242 31.8313L21.226 32.5362",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2571 11.7576L33.3394 10.4111",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_403_1725",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: -5,
    width: 32,
    height: 31
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7295 24.7541L41.4415 8.65024L25.3376 -4.06179L12.6256 12.0421L28.7295 24.7541Z",
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_403_1725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9502 18.4229L29.917 12.6245",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6264 9.54424L20.5894 18.1385",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4965 4.25211L24.1887 7.95294",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_403_1725",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: -5,
    width: 32,
    height: 31
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7295 24.7541L41.4415 8.65024L25.3376 -4.06179L12.6256 12.0421L28.7295 24.7541Z",
    fill: "white",
    stroke: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_403_1725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.0389 9.93741L26.0362 4.4096C25.8895 4.29384 25.7204 4.20984 25.5395 4.16293C25.3587 4.11602 25.1701 4.10723 24.9856 4.13711L21.0483 4.77503C20.5363 4.85798 20.1624 5.30365 20.1697 5.82229L20.3426 18.0961C20.3478 18.4638 20.6897 18.7337 21.0485 18.6534L33.027 15.9716C33.5332 15.8583 33.8798 15.3911 33.8416 14.8738L33.5479 10.8959C33.5341 10.7096 33.4818 10.5282 33.3941 10.3632C33.3065 10.1982 33.1856 10.0532 33.0389 9.93741Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1238 8.05078L29.5377 7.17365L29.9416 12.6432",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4216 5.12817L33.6439 15.5655",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7903 5.58716L33.504 2.14936",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2016 3.97268L28.8138 1.02212",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9612 7.73022L35.6889 6.44963",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.28d74731a38bd1871847011c27e26583.svg";
export { ForwardRef as ReactComponent };